import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, as: Tag = "span", className = "" }) => (
  <span className="mask-line">
    <motion.span
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
      className={`block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, dark = false, className = "" }) => (
  <FadeIn className={className}>
    <p className="eyebrow" data-testid="section-eyebrow">{eyebrow}</p>
    <div className="gold-rule mt-4 mb-6" />
    <h2
      className={`text-3xl sm:text-4xl lg:text-5xl font-serif tracking-tight leading-[1.15] ${
        dark ? "text-cream-50" : "text-forest-800"
      }`}
    >
      {title}
    </h2>
  </FadeIn>
);
